import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { useLinkProps, useRouterState } from '@tanstack/react-router';
import { isCurrentEntry } from './shellModel';

type NavLinkProps = { slug: string; to: string; children: ReactNode } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>;

/**
 * A navigation entry (sidebar, phone tab bar, More sheet): the router's link for navigating, `isCurrentEntry` for
 * `aria-current`. The router's own path matching is overridden because several entries share a link when there is no
 * project yet.
 */
export function NavLink({ slug, to, children, ...anchor }: NavLinkProps) {
  const current = useRouterState({ select: (st) => isCurrentEntry(slug, st.location.pathname) });
  const link = useLinkProps({ to, ...anchor });
  return (
    <a {...link} data-status={current ? 'active' : undefined} aria-current={current ? 'page' : undefined}>
      {children}
    </a>
  );
}
